import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const SwitchIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(7);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Switch Icon</title>;
    t1 = <path d="M3.57996 5.15991H17.42C19.08 5.15991 20.42 6.49991 20.42 8.15991V11.4799" />;
    t2 = <path d="M6.73996 2L3.57996 5.15997L6.73996 8.32001" />;
    t3 = <path d="M20.42 18.84H6.57996C4.91996 18.84 3.57996 17.5 3.57996 15.84V12.52" />;
    t4 = <path d="M17.26 21.9999L20.42 18.84L17.26 15.6799" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== props) {
    t5 = <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} {...props}>{t0}{t1}{t2}{t3}{t4}</svg>;
    $[5] = props;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};